import { StyledContent, StyledSection, StyledSubtitle } from '@/components/styles';
import { Credo } from '@/components';

const Mission = ({ data }) => {
  const { content, quote, subtitle, text, image, textImg } = data;

  return (
    <>
      {content && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: content }} dark/>
        </StyledContent.Description>
      )}
      {quote && (
        <StyledContent.Quote>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: quote }} />
        </StyledContent.Quote>
      )}
      <StyledSection pt="large" pb="none">
        <StyledSubtitle mb="small" size="large" left>
          {subtitle}
        </StyledSubtitle>
        {text && (
          <StyledContent.Description>
            <StyledContent.Html dangerouslySetInnerHTML={{ __html: text }} dark />
          </StyledContent.Description>
        )}
        <StyledContent.MissionRow>
          <Credo data={{ image, content: textImg }} />
        </StyledContent.MissionRow>
      </StyledSection>
    </>
  );
};

export default Mission;
